exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pXWQw span{white-space:nowrap;text-overflow:ellipsis}\n", ""]);

// Exports
exports.locals = {
	"add-ellipsis-to-breadcrumps": "pXWQw",
	"addEllipsisToBreadcrumps": "pXWQw"
};